var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      staticClass: "navigation-bottom",
      attrs: { "aria-label": "Bottom navigation" },
    },
    [
      _c("div", { staticClass: "row navigation-bottom__container" }, [
        _c(
          "div",
          {
            staticClass: "col-default-8 col-tablet-12 navigation-bottom__item",
          },
          [
            _c(
              "ul",
              { staticClass: "navigation-bottom__main" },
              _vm._l(_vm.data.main, function (item, index) {
                return _c("li", { key: index }, [
                  _c("a", {
                    attrs: { href: item.link, title: item.name },
                    domProps: { innerHTML: _vm._s(item.name) },
                  }),
                ])
              }),
              0
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-default-4 col-tablet-12" }, [
          _c(
            "ul",
            {
              staticClass:
                "navigation-bottom__main navigation-bottom__main--last",
            },
            _vm._l(_vm.data.second, function (item, index) {
              return _c("li", { key: index }, [
                _c("a", {
                  attrs: {
                    href: item.link,
                    title: item.name,
                    target: item.params && item.params.BLANK ? "_blank" : false,
                  },
                  domProps: { innerHTML: _vm._s(item.name) },
                }),
              ])
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "col-default-12 col-tablet-8 col-mobile-12 navigation-bottom__interfacs",
          },
          [
            _c("h6", { staticClass: "navigation-bottom__subscribtion-title" }, [
              _vm._v(
                "\n               " +
                  _vm._s(_vm.text.interfacs.title) +
                  "\n            "
              ),
            ]),
            _vm._v(" "),
            _c(
              "z-link",
              {
                attrs: {
                  href: "https://e-disclosure.ru/portal/company.aspx?id=942&attempt=1",
                  external: "",
                },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.text.interfacs.link) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "col-default-8 col-tablet-8 col-mobile-12 navigation-bottom__subscribtion",
          },
          [
            _c("h6", { staticClass: "navigation-bottom__subscribtion-title" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.text.subscription) +
                  "\n            "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "navigation-bottom__subscribtion-wrapper" },
              [
                _c("z-input", {
                  staticClass: "navigation-bottom__subscribtion-input",
                  attrs: {
                    name: "email",
                    type: "email",
                    required: "",
                    placeholder: "Email",
                  },
                  on: {
                    input: function ($event) {
                      _vm.email = $event
                    },
                    isValid: function ($event) {
                      _vm.isValid = $event
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "navigation-bottom__subscribtion-button",
                    class: {
                      "navigation-bottom__subscribtion-button--active":
                        _vm.isValid,
                    },
                    on: { click: _vm.subscribe },
                  },
                  [
                    _c("z-icon", {
                      attrs: {
                        name: "arrow",
                        dir: "right",
                        width: "24",
                        height: "24",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "col-default-3 col-default-offset-1 col-mobile-12 col-mobile-offset-0 navigation-bottom__subscribtion",
          },
          [
            _c(
              "div",
              { staticClass: "navigation-bottom__external-wrapper" },
              [
                _vm.data["external-links"]
                  ? _c(
                      "ul",
                      { staticClass: "navigation-bottom__external" },
                      _vm._l(
                        _vm.data["external-links"],
                        function (item, index) {
                          return _c("li", { key: index }, [
                            _c("a", {
                              attrs: {
                                href: item.link,
                                title: item.name,
                                target: "_blank",
                              },
                              domProps: { innerHTML: _vm._s(item.name) },
                            }),
                          ])
                        }
                      ),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("social", {
                  staticClass: "navigation-bottom__social",
                  attrs: {
                    links: _vm.social.links,
                    showCaption: "",
                    direction: "horizontal",
                  },
                }),
              ],
              1
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }